import { render, staticRenderFns } from "./account-setting.vue?vue&type=template&id=275422c0&"
import script from "./account-setting.vue?vue&type=script&lang=js&"
export * from "./account-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports